import { render, staticRenderFns } from "./InventoryItems.vue?vue&type=template&id=36f1ebc6&scoped=true"
import script from "./InventoryItems.vue?vue&type=script&lang=ts"
export * from "./InventoryItems.vue?vue&type=script&lang=ts"
import style0 from "./InventoryItems.vue?vue&type=style&index=0&id=36f1ebc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f1ebc6",
  null
  
)

export default component.exports